<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                                end-placeholder="结束日期"/>
            </el-form-item>
            <el-form-item>
                <el-input v-model="coinType" placeholder="输入币种"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="resetVisual()">查询</el-button>
            </el-form-item>
        </el-form>

        <el-card id="deposit" style="height:400px;"/>

        <el-card id="withdraw" style="margin-top: 20px;height:400px;"/>
    </div>
</template>

<script>
    import api from '../api';

    export default {
        name: "DWVisual",
        data() {
            return {
                time: [],
                coinType:'',
            }
        },
        methods: {
            resetVisual() {
                if (this.time) {
                    let queryInfo = {startTime: this.time[0], endTime: this.time[1], coinType: this.coinType};

                    api.getDepositVisual(queryInfo).then(response => {
                        let data = response.data;
                        let size = [];
                        for(let i = 0; i < data.discover.length; i++) {
                            size.push(i);
                        }
                        let chart = this.$echarts.init(document.getElementById('deposit'));
                        chart.setOption({
                            title: {
                                text: '充值时间可视化图表'
                            },
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'cross',
                                    label: {
                                        backgroundColor: '#6a7985'
                                    }
                                }
                            },
                            legend: {
                                data: ['发现时间', '确认时间', '人工确认', '入账时间','人工入账确认']
                            },
                            toolbox: {
                                feature: {
                                    saveAsImage: {}
                                }
                            },
                            grid: {
                                left: '3%',
                                right: '4%',
                                bottom: '3%',
                                containLabel: true
                            },
                            xAxis: [
                                {
                                    type: 'category',
                                    boundaryGap: false,
                                    data: size
                                }
                            ],
                            yAxis: [
                                {
                                    type: 'value'
                                }
                            ],
                            series: [
                                {
                                    name: '发现时间',
                                    type: 'line',
                                    stack: '总量',
                                    areaStyle: {},
                                    data: data.discover
                                },
                                {
                                    name: '确认时间',
                                    type: 'line',
                                    stack: '总量',
                                    areaStyle: {},
                                    data: data.netConfirm
                                },
                                {
                                    name: '人工确认',
                                    type: 'line',
                                    stack: '总量',
                                    areaStyle: {},
                                    data: data.manualConfirm
                                },
                                {
                                    name: '入账时间',
                                    type: 'line',
                                    stack: '总量',
                                    areaStyle: {},
                                    data: data.enterAccount
                                },
                                {
                                    name: '人工入账确认',
                                    type: 'line',
                                    stack: '总量',
                                    areaStyle: {},
                                    data: data.manualEnterConfirm
                                },
                            ]
                        })
                    });
                    api.getWithdrawVisual(queryInfo).then(response => {
                        let data = response.data;
                        let size = [];
                        for(let i = 0; i < data.manualConfirm.length; i++) {
                            size.push(i);
                        }
                        let chart = this.$echarts.init(document.getElementById('withdraw'));
                        chart.setOption({
                            title: {
                                text: '提现时间可视化图表'
                            },
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'cross',
                                    label: {
                                        backgroundColor: '#6a7985'
                                    }
                                }
                            },
                            legend: {
                                data: ['一审时间', '二审时间', '发送时间', '确认时间', '扣除冻结']
                            },
                            toolbox: {
                                feature: {
                                    saveAsImage: {}
                                }
                            },
                            grid: {
                                left: '3%',
                                right: '4%',
                                bottom: '3%',
                                containLabel: true
                            },
                            xAxis: [
                                {
                                    type: 'category',
                                    boundaryGap: false,
                                    data: size
                                }
                            ],
                            yAxis: [
                                {
                                    type: 'value'
                                }
                            ],
                            series: [
                                {
                                    name: '一审时间',
                                    type: 'line',
                                    stack: '总量',
                                    areaStyle: {},
                                    data: data.manualConfirm
                                },
                                {
                                    name: '二审时间',
                                    type: 'line',
                                    stack: '总量',
                                    areaStyle: {},
                                    data: data.reCheckTime
                                },
                                {
                                    name: '发送时间',
                                    type: 'line',
                                    stack: '总量',
                                    areaStyle: {},
                                    data: data.sendTransfer
                                },
                                {
                                    name: '确认时间',
                                    type: 'line',
                                    stack: '总量',
                                    areaStyle: {},
                                    data: data.netConfirm
                                },
                                {
                                    name: '扣除冻结',
                                    type: 'line',
                                    stack: '总量',
                                    label: {
                                        normal: {
                                            show: true,
                                            position: 'top'
                                        }
                                    },
                                    areaStyle: {},
                                    data: data.enterAccount
                                }
                            ]
                        })
                    });
                } else {
                    this.$message.error('时间参数不能为空');
                }
            }
        },
        created() {
            let time = new Date();
            let year = time.getFullYear();
            let month = time.getMonth();
            let day = time.getDate();
            this.time[0] = new Date(year, month, day, 0, 0, 0);
            this.time[1] = new Date(year, month, day, 23, 59, 59);
        },
        mounted() {
            this.resetVisual();
        }
    }
</script>

<style scoped>

</style>
